import {Yii} from "libraries/interfaces/Yii";

export const TEMPLATE_LABELS: { [key: string]: string } = {
    treatmentSearch: Yii.t('wui-sasha-js', 'Recherche de traitements'),
    newSearch: Yii.t('wui-sasha-js', 'Nouvelle recherche'),
};

export const FIELD_LABELS: { [key: string]: string } = {
    status: Yii.t('wui-sasha-js', 'Statut(s)'),
    type: Yii.t('wui-sasha-js', 'Types de traitement'),
    whenCreated: Yii.t('wui-sasha-js', 'Date de traitement'),
    whenCreatedMin: Yii.t('wui-sasha-js', 'Traité entre le'),
    whenCreatedMax: Yii.t('wui-sasha-js', 'et le'),
};